import { Button, PanelRow, SelectControl } from '@wordpress/components';
import { useState } from '@wordpress/element'
import React from 'react';

const SidebarAutocompleteList = (props) => {
    const [selectedItem, setSelectedItem] = useState(null);
    const [institutions, setInstitutions] = useState(props.institutions);
    const [selectedInstitution, setSelectedInstitution] = useState();
    const [items, setItems] = useState([]);
    const [allAxis, setAllAxis] = useState([]);
    const [xAxis, setXAxis] = useState();
    const [yAxis, setYAxis] = useState();

    const handleSelectXAxis = (value) => {        
        if (items[value]){
            const itemsSlice = items[value]
            const limit = parseInt(props.limit)
            const obj = Object.entries(itemsSlice).slice(0, limit)
            const newData = [['Categoria', value], ...obj];
            setXAxis(value)
            props.onChange(newData)
        }
    }

    const handleSelectYAxis = (value) => {
        setYAxis(value)
        selectYAxis(value)
    }

    const selectYAxis = async (paramYAxis) => {
        try {
            const response = await fetch(`${wpApiSettings.root}casaca/institution/get_items?id=${selectedInstitution}&xAxis=${xAxis}&yAxis=${paramYAxis}&limit=${props.limit}`)
            const responseData = await response.json();

            if (responseData.data.result.length >= 1){
                props.onChange(responseData.data.result.slice(0, props.limit))
            }

        } catch (error) {
            console.log(error)
        }
    }

    const selectInstitution = async (index, termID) => {
        setSelectedItem(index)
        setSelectedInstitution(termID)
        try {
            const response = await fetch(`${wpApiSettings.root}casaca/institution/get_items?id=${termID}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'X-WP-Nonce': wpApiSettings.nonce
                }
            })
            const responseData = await response.json();

            if (responseData.data.axis.length >= 1) {
                const axis = responseData.data.axis.map(element => ({ label: element, value: element }));
                setAllAxis(axis)
                setItems(responseData.data.types)
            }

        } catch (error) {
            console.log(error)
        }
    }

    return (
        <>
            {institutions.length > 0 && (
                <>
                <PanelRow>
                    <ul style={{ marginTop: '10px', padding: 0 }}>
                        {institutions.map((suggestion, index) => (
                            <li
                                key={index}
                                style={{
                                    cursor: 'pointer', 
                                    listStyle: 'none', 
                                    padding: '5px',
                                    backgroundColor: selectedItem === index ? '#f7f7f7' : 'transparent',
                                }}
                                onClick={() => {selectInstitution(index, suggestion.term_id)}}
                            >
                                {suggestion.title}
                                <br />
                            </li>
                        ))}
                    </ul>
                </PanelRow>
                </>
            )}
            {allAxis?.length > 0 && (
                <>
                    <PanelRow>
                        <SelectControl
                            label="1ª Série"
                            value={ xAxis }
                            options={allAxis}
                            onChange={(value) => { handleSelectXAxis(value) }}
                            __next40pxDefaultSize
                            __nextHasNoMarginBottom
                        />
                    </PanelRow>
                </>
            )}

            {allAxis?.length > 0 && props?.yAxis == true && (
                <>
                    <PanelRow>
                        <SelectControl
                            label="2ª Série"
                            value={ yAxis }
                            options={allAxis}
                            onChange={(value) => { handleSelectYAxis(value) }}
                            __next40pxDefaultSize
                            __nextHasNoMarginBottom
                        />
                    </PanelRow>
                </>
            )}
        </>
    )
}

export default SidebarAutocompleteList
